// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import GlobalStyles from '../../../../../../../config/styles';

const styles = ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  blockContainer: {
    margin: '15px 0',
  },
  arrowBackContainer: {
    margin: '5px 0 0',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  link: {
    color: GlobalStyles.color.COLOR_SECONDARY,
  },
});

export default styles;
